import angular from "angular";
import confirmDestructiveActionDialogPreset from "./confirm_destructive_action.config";

export default angular
    .module("sbApp.dialogs.confirmDestructiveActionDialog", [])
    .config(confirmDestructiveActionDialogPreset);
